import { createContext } from 'react';
import { UnityDetail } from '@/custom-types';

export type AddUnityFormModalContextProps = {
  closeModal: () => void
  openModal: (unityData?: UnityDetail) => void
  unityData: UnityDetail | null
  isOpen: boolean
}

export const AddUnityFormModalContext = createContext<AddUnityFormModalContextProps | null>(null)